import React from 'react';

const canvas = document.createElement('canvas');

export function useMeasureTextWidth(): (
  ref: React.RefObject<HTMLElement>,
) => (displayText: string) => number {
  const refCache = React.useRef<Map<React.RefObject<HTMLElement>, Map<string, number>>>(new Map());

  return React.useCallback((ref: React.RefObject<HTMLElement>) => {
    if (!ref.current) {
      throw new Error('ref.current must be a valid HTML element');
    }

    // Verify ref.current is an HTMLElement
    if (!(ref.current instanceof HTMLElement)) {
      throw new Error('ref.current must be an HTMLElement');
    }

    const context = canvas.getContext('2d');

    if (!context) {
      throw new Error('Context is not set');
    }

    context.font = window.getComputedStyle(ref.current).font;

    if (!refCache.current.has(ref)) {
      refCache.current.set(ref, new Map());
    }

    const measureCache = refCache.current.get(ref) ?? new Map();

    return (displayText: string) => {
      if (typeof displayText !== 'string') {
        throw new Error('displayText must be a string');
      }

      if (measureCache.has(displayText)) {
        return measureCache.get(displayText) ?? 0;
      }

      const width = context.measureText(displayText).width;
      measureCache.set(displayText, width);

      return width;
    };
  }, []);
}
